// Ikony - komponenty SVG (obrys w kolorze tekstu: stroke="currentColor").
// Użycie: <IkonaPulpit /> albo <IkonaPulpit className="..." />. Zawsze aria-hidden - opis daje przycisk/etykieta.
// Jeden adres importu dla całej APP: tu nawigacja i akcje, reszta w ikony-dalsze.tsx (limit 300 linii na plik).
import { Svg, type IkonaProps } from "./ikony-svg";

export type { IkonaProps, KomponentIkony } from "./ikony-svg";
export * from "./ikony-dalsze";

export function IkonaPulpit(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="3" width="7" height="9" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" /><rect x="14" y="12" width="7" height="9" rx="1.5" /><rect x="3" y="16" width="7" height="5" rx="1.5" /></Svg>;
}

export function IkonaUrzadzenia(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="13" width="18" height="8" rx="2" /><path d="M7 17h.01M11 17h.01" /><path d="M8.5 9.5a5 5 0 0 1 7 0M6 7a8.5 8.5 0 0 1 12 0" /></Svg>;
}

export function IkonaStatystyki(props: IkonaProps) {
  return <Svg {...props}><path d="M3 3v18h18" /><path d="m7 15 4-5 3 3 5-7" /></Svg>;
}

export function IkonaAlarmy(props: IkonaProps) {
  return <Svg {...props}><path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></Svg>;
}

export function IkonaAsystent(props: IkonaProps) {
  return <Svg {...props}><path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /><path d="M8 9h8M8 13h5" /></Svg>;
}

export function IkonaPrzepisy(props: IkonaProps) {
  return <Svg {...props}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z" /><path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5" /></Svg>;
}

export function IkonaPlany(props: IkonaProps) {
  return <Svg {...props}><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /><path d="m9 16 2 2 4-4" /></Svg>;
}

export function IkonaEnergia(props: IkonaProps) {
  return <Svg {...props}><path d="M13 2 3 14h9l-1 8 10-12h-9z" /></Svg>;
}

export function IkonaOsiagniecia(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="14" r="7" /><path d="M8.2 8.2 6 2h4l2 4 2-4h4l-2.2 6.2" /><path d="M12 11v6M9.5 14h5" /></Svg>;
}

export function IkonaSerwis(props: IkonaProps) {
  return <Svg {...props}><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></Svg>;
}

export function IkonaUsterka(props: IkonaProps) {
  return <Svg {...props}><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4M12 17h.01" /></Svg>;
}

export function IkonaInstrukcje(props: IkonaProps) {
  return <Svg {...props}><path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z" /><path d="M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z" /></Svg>;
}

export function IkonaUstawienia(props: IkonaProps) {
  return <Svg {...props}><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" /></Svg>;
}

export function IkonaWyloguj(props: IkonaProps) {
  return <Svg {...props}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5M21 12H9" /></Svg>;
}

export function IkonaWiecej(props: IkonaProps) {
  return <Svg {...props}><path d="M4 6h16M4 12h16M4 18h16" /></Svg>;
}

export function IkonaKropki(props: IkonaProps) {
  return <Svg {...props}><circle cx="5" cy="12" r="1.2" /><circle cx="12" cy="12" r="1.2" /><circle cx="19" cy="12" r="1.2" /></Svg>;
}

export function IkonaSzukaj(props: IkonaProps) {
  return <Svg {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></Svg>;
}

export function IkonaPlus(props: IkonaProps) {
  return <Svg {...props}><path d="M12 5v14M5 12h14" /></Svg>;
}

export function IkonaMinus(props: IkonaProps) {
  return <Svg {...props}><path d="M5 12h14" /></Svg>;
}

export function IkonaX(props: IkonaProps) {
  return <Svg {...props}><path d="M18 6 6 18M6 6l12 12" /></Svg>;
}

export function IkonaCheck(props: IkonaProps) {
  return <Svg {...props}><path d="M20 6 9 17l-5-5" /></Svg>;
}

export function IkonaWPrawo(props: IkonaProps) {
  return <Svg {...props}><path d="m9 18 6-6-6-6" /></Svg>;
}

export function IkonaWLewo(props: IkonaProps) {
  return <Svg {...props}><path d="m15 18-6-6 6-6" /></Svg>;
}

export function IkonaWDol(props: IkonaProps) {
  return <Svg {...props}><path d="m6 9 6 6 6-6" /></Svg>;
}

export function IkonaWGore(props: IkonaProps) {
  return <Svg {...props}><path d="m18 15-6-6-6 6" /></Svg>;
}

export function IkonaStrzalkaPrawo(props: IkonaProps) {
  return <Svg {...props}><path d="M5 12h14M13 6l6 6-6 6" /></Svg>;
}

export function IkonaEdytuj(props: IkonaProps) {
  return <Svg {...props}><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" /></Svg>;
}

export function IkonaUsun(props: IkonaProps) {
  return <Svg {...props}><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></Svg>;
}

export function IkonaUdostepnij(props: IkonaProps) {
  return <Svg {...props}><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4" /></Svg>;
}

export function IkonaOsoba(props: IkonaProps) {
  return <Svg {...props}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></Svg>;
}

export function IkonaOsoby(props: IkonaProps) {
  return <Svg {...props}><circle cx="9" cy="8" r="4" /><path d="M2 21a7 7 0 0 1 14 0" /><path d="M16 3.5a4 4 0 0 1 0 8M22 21a7 7 0 0 0-4-6.3" /></Svg>;
}

export function IkonaWifi(props: IkonaProps) {
  return <Svg {...props}><path d="M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0M2 9a15 15 0 0 1 20 0M12 20h.01" /></Svg>;
}

export function IkonaWifiOff(props: IkonaProps) {
  return <Svg {...props}><path d="m2 2 20 20M8.5 16a5 5 0 0 1 7 0M5 12.5a10 10 0 0 1 4-2.4M16.7 10.6a10 10 0 0 1 2.3 1.9M2 9a15 15 0 0 1 4.2-2.8M10.7 5.1A15 15 0 0 1 22 9M12 20h.01" /></Svg>;
}
